export default __webpack_public_path__ + "static/media/ConnorRoche.2bba3cd4.jpg";